import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';

export default function VBar(props) {
  return (
    <div {...ex('VBar', props)}>
    </div>
  );
}

